module.exports = __webpack_public_path__ + "img/Counting01-min.a452207b.png";